<template>
  <transition name="bs-fade">
    <div v-if="isShow" class="bs-overlay" @click.self="close">
      <transition name="bs-slide">
        <div v-if="isShow" class="bs-sheet">
          <!-- Header -->
          <div class="bs-header">
            <button class="bs-close-btn" type="button" aria-label="Đóng" @click="close">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
            <h5 class="bs-title">XÁC THỰC BẢO MẬT</h5>
          </div>

          <!-- Body -->
          <div class="bs-body">
            <p class="bs-desc">Vui lòng chọn hình thức xác thực để hoàn tất quá trình xác nhận.</p>

            <!-- Option: Email -->
            <label v-if="query.email" class="auth-option w-100 mb-3">
              <input
                type="radio"
                name="authMethod"
                class="d-none"
                value="EMAIL"
                v-model="selectedMethod"
              />
              <div class="option-content d-flex align-items-center p-3 rounded-3">
                <div class="auth-radio flex-shrink-0"></div>
                <div
                  class="auth-icon-wrapper flex-shrink-0 rounded-circle d-flex justify-content-center align-items-center mx-3"
                >
                  <img src="@/assets/img/nganluong/icon-mail.svg" alt="Email" />
                </div>
                <div class="text-start">
                  <div class="fw-bold text-dark" style="font-size: 15px">Gửi qua Email</div>
                  <div class="text-muted" style="font-size: 14px; font-weight: 500">
                    {{ query.email | maskEmail }}
                  </div>
                </div>
              </div>
            </label>

            <!-- Option: Zalo -->
            <label v-if="mobile && !isHidenZns" class="auth-option w-100 mb-3">
              <input
                type="radio"
                name="authMethod"
                class="d-none"
                value="ZNS"
                v-model="selectedMethod"
              />
              <div class="option-content d-flex align-items-center p-3 rounded-3">
                <div class="auth-radio flex-shrink-0"></div>
                <div
                  class="auth-icon-wrapper flex-shrink-0 rounded-circle d-flex justify-content-center align-items-center mx-3"
                >
                  <img src="@/assets/img/nganluong/icon-zalo.svg" alt="Zalo" />
                </div>
                <div class="text-start">
                  <div class="fw-bold text-dark" style="font-size: 15px">Gửi qua Zalo</div>
                  <div class="text-muted" style="font-size: 14px; font-weight: 500">
                    {{ maskedPhone }}
                  </div>
                </div>
              </div>
            </label>

            <!-- Option: SMS -->
            <label v-if="mobile" class="auth-option w-100 mb-3">
              <input
                type="radio"
                name="authMethod"
                class="d-none"
                value="SMS"
                v-model="selectedMethod"
              />
              <div class="option-content d-flex align-items-center p-3 rounded-3">
                <div class="auth-radio flex-shrink-0"></div>
                <div
                  class="auth-icon-wrapper flex-shrink-0 rounded-circle d-flex justify-content-center align-items-center mx-3"
                >
                  <img src="@/assets/img/nganluong/icon-phone.svg" alt="Phone" />
                </div>
                <div class="text-start">
                  <div class="fw-bold text-dark" style="font-size: 15px">Gửi qua tin nhắn SMS</div>
                  <div class="text-muted" style="font-size: 14px; font-weight: 500">
                    {{ maskedPhone }}
                  </div>
                </div>
              </div>
            </label>

            <!-- Option: CCCD -->
            <!-- <label class="auth-option w-100 mb-4">
              <input type="radio" name="authMethod" class="d-none" value="cccd" v-model="selectedMethod">
              <div class="option-content d-flex align-items-center p-3 rounded-3">
                <div class="auth-radio flex-shrink-0"></div>
                <div
                  class="auth-icon-wrapper flex-shrink-0 rounded-circle d-flex justify-content-center align-items-center mx-3">
                  <img src="@/assets/img/nganluong/icon-cccd.svg" alt="CCCD">
                </div>
                <div class="text-start">
                  <div class="fw-bold text-dark" style="font-size: 15px;">Nhập số Căn cước người đại diện</div>
                  <div class="text-muted" style="font-size: 14px; font-weight: 500;">{{ maskedCccd }}</div>
                </div>
              </div>
            </label> -->

            <button
              type="button"
              class="btn btn-primary w-100 fw-bold py-3"
              style="font-size: 17px; border-radius: 12px"
              @click="handleContinue"
            >
              Tiếp tục
            </button>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
  import { contractNLOtp } from '@/services/customer-support/task'

  export default {
    name: 'PopupSendOtp',
    props: ['query', 'updateShowLoading', 'mobile'],
    data() {
      return {
        isShow: false,
        isLoading: false,
        selectedMethod: 'EMAIL',
      }
    },

    computed: {
      maskedPhone() {
        const phone = this.mobile || ''
        if (!phone) return ''
        return phone.replace(/(\d{2})\d{5}(\d{2})/, '$1** *** *$2')
      },
      isHidenZns() {
        const date = new Date()
        const house = date.getHours()
        return house >= 22 || house < 6
      },
    },

    methods: {
      show() {
        document.body.style.overflow = 'hidden'

        if (!this.mobile) {
          this.selectedMethod = 'EMAIL'
          this.handleContinue()
        } else {
          this.isShow = true
        }
      },

      close() {
        this.isShow = false
        document.body.style.overflow = ''
      },

      async handleContinue() {
        try {
          this.updateShowLoading(true)
          const response = await contractNLOtp({
            ...this.query,
            typeSend: this.selectedMethod,
          })
          if (response.code === 1000) {
            this.$emit('method', this.selectedMethod)
            this.$emit('next-step')
            this.close()
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error.response?.data?.message ?? error.message)
        } finally {
          this.updateShowLoading(false)
        }
      },
    },
  }
</script>

<style scoped>
  /* Overlay */
  .bs-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    z-index: 1000;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  /* Sheet */
  .bs-sheet {
    max-width: 440px;
    background: #fff;
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    padding-bottom: env(safe-area-inset-bottom, 0px);
    max-height: 92vh;
    overflow-y: auto;
  }

  /* Drag handle (optional visual) */
  .bs-sheet::before {
    content: '';
    display: block;
    width: 40px;
    height: 4px;
    background: #e0e0e0;
    border-radius: 2px;
    margin: 12px auto 0;
  }

  /* Header */
  .bs-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 56px 12px;
  }

  .bs-close-btn {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding: 6px;
    cursor: pointer;
    color: #444;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background 0.15s;
  }

  .bs-close-btn:hover {
    background: #f0f0f0;
  }

  .bs-title {
    font-size: 18px;
    font-weight: 700;
    color: #222;
    margin: 0;
    text-align: center;
  }

  /* Body */
  .bs-body {
    padding: 8px 20px 24px;
  }

  .bs-desc {
    text-align: center;
    color: #666;
    font-size: 15px;
    margin-bottom: 20px;
    line-height: 1.5;
  }

  /* Transitions */
  .bs-fade-enter-active,
  .bs-fade-leave-active {
    transition: opacity 0.25s ease;
  }

  .bs-fade-enter,
  .bs-fade-leave-to {
    opacity: 0;
  }

  .bs-slide-enter-active,
  .bs-slide-leave-active {
    transition:
      transform 0.35s cubic-bezier(0.32, 0.72, 0, 1),
      opacity 0.35s ease;
  }

  .bs-slide-enter,
  .bs-slide-leave-to {
    transform: translateY(100%);
    opacity: 0;
  }
</style>
